(function () {
  'use strict';

  /* ==========================================
     CUSTOM PRINT STUDIO v11 — Complete JS
     Glowy-waves hero canvas, 360° gallery, Fabric.js
     Progressive enhancement: page works without JS
     Zero model-viewer / GLB dependencies
     ========================================== */

  // ====== COLOR MAP ======
  var colorMap = {
    'black':'#222222','white':'#ffffff','red':'#cc0000','blue':'#0044cc','green':'#00aa00',
    'yellow':'#ffcc00','orange':'#ff8800','purple':'#800080','pink':'#ff69b4','brown':'#8b4513',
    'gray':'#808080','grey':'#808080','navy':'#001f5c','teal':'#008080','olive':'#808000',
    'maroon':'#800000','lime':'#00ff00','cyan':'#00cccc','magenta':'#ff00ff','silver':'#c0c0c0',
    'gold':'#daa520','tan':'#d2b48c','beige':'#f5f5dc','khaki':'#bdb76b','salmon':'#fa8072',
    'coral':'#ff7f50','ivory':'#fffff0','cream':'#fffdd0','charcoal':'#333333',
    'heather gray':'#9e9e9e','heather grey':'#9e9e9e','light blue':'#add8e6','forest green':'#228b22'
  };

  // ====== DOM ======
  var D = {};
  function cacheDom() {
    try {
      var g = function (id) { return document.getElementById(id); };
      D.root = g('cps-root');
      D.heroCanvas = g('cps-hero-canvas');
      D.heroImg = g('cps-hero-img');
      D.viewButtons = g('cps-view-buttons');
      D.viewLabel = g('cps-view-label');
      D.galleryToggle = g('cps-gallery-toggle');
      D.colorDisplay = g('cps-color-display');
      D.stage = g('cps-stage');
      D.svgLayer = g('cps-svg-layer');
      D.canvasLayer = g('cps-canvas-layer');
      D.fabricCanvas = g('cps-fabric');
      D.galleryLayer = g('cps-gallery-layer');
      D.galleryImg = g('cps-gallery-img');
      D.galleryPrev = g('cps-gallery-prev');
      D.galleryNext = g('cps-gallery-next');
      D.galleryDots = g('cps-gallery-dots');
      D.loader = g('cps-loader');
      D.loaderText = g('cps-loader-text');
      D.tabs = g('cps-tabs');
      D.sizeButtons = g('cps-size-buttons');
      D.sizeName = g('cps-size-name');
      D.sizeWrap = g('cps-size-wrap');
      D.colorSwatches = g('cps-color-swatches');
      D.colorName = g('cps-color-name');
      D.placementButtons = g('cps-placement-buttons');
      D.uploadZone = g('cps-upload-zone');
      D.fileInput = g('cps-file-input');
      D.artThumb = g('cps-art-thumb');
      D.artName = g('cps-art-name');
      D.removeArt = g('cps-remove-art');
      D.uploadThumbWrap = g('cps-upload-thumb');
      D.textInput = g('cps-text-input');
      D.fontSelect = g('cps-font-select');
      D.textColor = g('cps-text-color');
      D.fontSize = g('cps-font-size');
      D.fontSizeVal = g('cps-fontsize-val');
      D.addText = g('cps-add-text');
      D.notes = g('cps-notes');
      D.qtyMinus = g('cps-qty-minus');
      D.qtyVal = g('cps-qty-val');
      D.qtyPlus = g('cps-qty-plus');
      D.proofToggle = g('cps-proof-toggle');
      D.price = g('cps-price');
      D.meta = g('cps-meta');
      D.addToCart = g('cps-add-to-cart');
      D.toasts = g('cps-toasts');
      D.photoStrip = g('cps-photo-strip');
      D.styleSelect = g('cps-style-select');
      D.styleWrap = g('cps-style-wrap');
    } catch (e) { console.error('CPS: cacheDom error', e); }
  }

  // ====== STATE ======
  var state = {
    product: 'tshirt', view: 'front', color: null, size: null, style: null,
    placement: 'Front', artworkFile: null, artworkDataURL: null,
    qty: 1, proof: false, notes: '', fabricCanvas: null,
    variant: null, galleryIdx: 0, modeGallery: false, galleryImages: []
  };

  // ====== DATA ======
  var cpData = { products: {}, imgs: {} };

  // ====== UTILS ======
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
  function hex(name) { return colorMap[(name || '').toLowerCase().trim()] || '#222222'; }
  function debounce(fn, ms) { var t; return function () { var s = this, a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function productLabel(k) { return { tshirt: 'T-Shirt', hoodie: 'Hoodie', hat: 'Hat', shoes: 'Shoes' }[k] || k; }

  // ====== TOAST ======
  function toast(msg, type) {
    try {
      if (!D.toasts) return;
      var el = document.createElement('div');
      el.className = 'cps-toast' + (type ? ' cps-toast--' + type : '');
      el.textContent = msg;
      D.toasts.appendChild(el);
      setTimeout(function () { el.style.opacity = '0'; el.style.transition = 'opacity 0.2s'; setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 250); }, 3500);
    } catch (e) {}
  }

  // ============================================================
  //  HERO CANVAS WAVE ANIMATION (inspired by glowy-waves-hero)
  // ============================================================
  var heroAnim = { rafId: null, running: false };

  function initHeroCanvas() {
    try {
      if (!D.heroCanvas) return;

      // Respect reduced motion
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        drawStaticHero();
        return;
      }

      var canvas = D.heroCanvas;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;

      var dpr = Math.min(window.devicePixelRatio || 1, 2);

      function resize() {
        var hero = canvas.parentElement;
        if (!hero) return;
        var rect = hero.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        canvas.style.width = rect.width + 'px';
        canvas.style.height = rect.height + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      resize();
      window.addEventListener('resize', debounce(resize, 200));

      // Wave configuration — warm accent palette
      var waves = [
        { amplitude: 60, wavelength: 800, speed: 0.0008, yOffset: 0.35, color: 'rgba(201,149,107,0.08)', lineWidth: 2 },
        { amplitude: 45, wavelength: 600, speed: 0.0012, yOffset: 0.45, color: 'rgba(201,149,107,0.06)', lineWidth: 1.5 },
        { amplitude: 80, wavelength: 1000, speed: 0.0006, yOffset: 0.55, color: 'rgba(201,149,107,0.05)', lineWidth: 2.5 },
        { amplitude: 35, wavelength: 500, speed: 0.0015, yOffset: 0.65, color: 'rgba(201,149,107,0.07)', lineWidth: 1 },
        { amplitude: 55, wavelength: 700, speed: 0.001, yOffset: 0.75, color: 'rgba(201,149,107,0.04)', lineWidth: 2 }
      ];

      // Glowing orbs
      var orbs = [
        { x: 0.2, y: 0.3, radius: 120, color: 'rgba(201,149,107,0.06)', speed: 0.0003, phaseX: 0, phaseY: 0 },
        { x: 0.7, y: 0.5, radius: 100, color: 'rgba(201,149,107,0.04)', speed: 0.0004, phaseX: 1.5, phaseY: 0.8 },
        { x: 0.5, y: 0.7, radius: 150, color: 'rgba(201,149,107,0.05)', speed: 0.00025, phaseX: 3, phaseY: 2 }
      ];

      heroAnim.running = true;

      function animate(time) {
        if (!heroAnim.running) return;

        var w = canvas.width / dpr;
        var h = canvas.height / dpr;

        ctx.clearRect(0, 0, w, h);

        // Draw orbs (soft radial gradients)
        orbs.forEach(function (orb) {
          var ox = orb.x * w + Math.sin(time * orb.speed + orb.phaseX) * 50;
          var oy = orb.y * h + Math.cos(time * orb.speed + orb.phaseY) * 40;
          var grad = ctx.createRadialGradient(ox, oy, 0, ox, oy, orb.radius);
          grad.addColorStop(0, orb.color);
          grad.addColorStop(1, 'rgba(201,149,107,0)');
          ctx.fillStyle = grad;
          ctx.beginPath();
          ctx.arc(ox, oy, orb.radius, 0, Math.PI * 2);
          ctx.fill();
        });

        // Draw waves
        waves.forEach(function (wave) {
          ctx.strokeStyle = wave.color;
          ctx.lineWidth = wave.lineWidth;
          ctx.beginPath();

          var baseY = h * wave.yOffset;
          var step = 4;

          for (var x = 0; x <= w; x += step) {
            var y = baseY + Math.sin((x / wave.wavelength) * Math.PI * 2 + time * wave.speed) * wave.amplitude;
            y += Math.sin((x / (wave.wavelength * 0.5)) * Math.PI * 2 + time * wave.speed * 1.5) * (wave.amplitude * 0.3);
            if (x === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
          }
          ctx.stroke();
        });

        // Subtle noise particles
        var particleCount = Math.min(12, Math.floor(w / 100));
        for (var i = 0; i < particleCount; i++) {
          var px = (Math.sin(time * 0.0002 + i * 2.1) * 0.5 + 0.5) * w;
          var py = (Math.cos(time * 0.00015 + i * 1.7) * 0.5 + 0.5) * h;
          var pr = 1 + Math.sin(time * 0.001 + i) * 0.5;
          var pa = 0.1 + Math.sin(time * 0.0005 + i * 3) * 0.06;
          ctx.fillStyle = 'rgba(201,149,107,' + pa + ')';
          ctx.beginPath();
          ctx.arc(px, py, pr, 0, Math.PI * 2);
          ctx.fill();
        }

        heroAnim.rafId = requestAnimationFrame(animate);
      }

      heroAnim.rafId = requestAnimationFrame(animate);

      // Pause when hero is not visible
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!heroAnim.running) {
                heroAnim.running = true;
                heroAnim.rafId = requestAnimationFrame(animate);
              }
            } else {
              heroAnim.running = false;
              if (heroAnim.rafId) cancelAnimationFrame(heroAnim.rafId);
            }
          });
        }, { threshold: 0.1 });
        observer.observe(canvas.parentElement);
      }

    } catch (e) { console.error('CPS: initHeroCanvas error', e); }
  }

  function drawStaticHero() {
    try {
      if (!D.heroCanvas) return;
      var canvas = D.heroCanvas;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var hero = canvas.parentElement;
      if (!hero) return;
      var rect = hero.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';

      // Draw static orbs only
      var w = rect.width, h = rect.height;
      var orbs = [
        { x: 0.2 * w, y: 0.3 * h, r: 120, a: 0.06 },
        { x: 0.7 * w, y: 0.5 * h, r: 100, a: 0.04 },
        { x: 0.5 * w, y: 0.7 * h, r: 150, a: 0.05 }
      ];
      orbs.forEach(function (o) {
        var grad = ctx.createRadialGradient(o.x, o.y, 0, o.x, o.y, o.r);
        grad.addColorStop(0, 'rgba(201,149,107,' + o.a + ')');
        grad.addColorStop(1, 'rgba(201,149,107,0)');
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(o.x, o.y, o.r, 0, Math.PI * 2);
        ctx.fill();
      });
    } catch (e) {}
  }

  // ====== SVG PREVIEW ======
  function templateKey() {
    var p = state.product, v = state.view;
    if (p === 'shoes') return 'shoes-side';
    if (p === 'hat') return v === 'back' ? 'hat-side' : 'hat-front';
    return p + '-' + v;
  }

  function renderSVG() {
    try {
      if (!D.svgLayer) return;
      var key = templateKey();
      var tpl = document.querySelector('.cps-templates [data-template="' + key + '"]');
      if (!tpl) {
        D.svgLayer.innerHTML = '<div style="color:#8a8680;font-size:14px;text-align:center;padding:40px;">No preview for this view</div>';
        return;
      }
      var clone = tpl.cloneNode(true);
      clone.removeAttribute('data-template');
      clone.style.display = '';
      var h = hex(state.color);
      var fills = clone.querySelectorAll('.cps-fill');
      for (var i = 0; i < fills.length; i++) { fills[i].setAttribute('fill', h); }
      D.svgLayer.innerHTML = '';
      D.svgLayer.appendChild(clone);
    } catch (e) { console.error('CPS: renderSVG error', e); }
  }

  // ====== LOADER ======
  function showLoader(text) { try { if (D.loader) D.loader.classList.add('is-visible'); if (D.loaderText) D.loaderText.textContent = text || 'Loading...'; } catch (e) {} }
  function hideLoader() { try { if (D.loader) D.loader.classList.remove('is-visible'); } catch (e) {} }

  // ====== VIEW MANAGEMENT ======
  function show2D() {
    try {
      state.modeGallery = false;
      if (D.galleryLayer) {
        D.galleryLayer.classList.remove('is-visible');
        D.galleryLayer.classList.remove('is-view-mode');
      }
      if (D.svgLayer) D.svgLayer.style.display = 'flex';
      if (D.canvasLayer) D.canvasLayer.style.display = 'flex';
      updateViewUI();
    } catch (e) { console.error('CPS: show2D error', e); }
  }

  // ====== BG PHOTO (view-mode gallery) ======
  // Shows the product photo for the current product+view in the gallery layer.
  // Falls back to SVG wireframe when no photo is available.
  function updateBgPhoto() {
    try {
      var imgKeyMap = {
        'tshirt-front':  'tshirt-front',  'tshirt-back':   'tshirt-back',
        'tshirt-left':   'tshirt-left',   'tshirt-right':  'tshirt-right',
        'hoodie-front':  'hoodie-front',  'hoodie-back':   'hoodie-back',
        'hoodie-left':   'hoodie-left',   'hoodie-right':  'hoodie-right',
        'hat-front':     'hat-front',     'hat-side':      'hat-side',
        'shoes-side':    'sneakers-side'
      };
      var key = imgKeyMap[state.product + '-' + state.view];
      if (!key) { show2D(); return; }
      var url = resolveImgUrl(key);
      if (!url) { show2D(); return; }
      // Show gallery layer in single-view mode (nav arrows/dots hidden via CSS)
      if (D.galleryImg) { D.galleryImg.src = url; D.galleryImg.alt = key.replace(/-/g, ' '); }
      if (D.galleryLayer) {
        D.galleryLayer.classList.add('is-visible');
        D.galleryLayer.classList.add('is-view-mode');
      }
      if (D.svgLayer) D.svgLayer.style.display = 'none';
      // Canvas (z-index 4) stays on top of gallery (z-index 3) for design overlay
      updateViewUI();
    } catch (e) { console.error('CPS: updateBgPhoto error', e); show2D(); }
  }

  // Dynamically rebuild view buttons for the current product.
  function updateViewButtons() {
    try {
      if (!D.viewButtons) return;
      var viewDefs = {
        tshirt: [{view:'front',label:'Front'},{view:'back',label:'Back'},{view:'left',label:'Left'},{view:'right',label:'Right'}],
        hoodie: [{view:'front',label:'Front'},{view:'back',label:'Back'},{view:'left',label:'Left'},{view:'right',label:'Right'}],
        hat:    [{view:'front',label:'Front'},{view:'side',label:'Side'}],
        shoes:  [{view:'side',label:'Side'}]
      };
      var views = viewDefs[state.product] || [{view:'front',label:'Front'}];
      if (!views.some(function (v) { return v.view === state.view; })) state.view = views[0].view;
      D.viewButtons.innerHTML = '';
      views.forEach(function (v) {
        var btn = document.createElement('button');
        btn.className = 'cps-view-btn' + (v.view === state.view ? ' is-active' : '');
        btn.dataset.view = v.view;
        btn.textContent = v.label;
        btn.addEventListener('click', function () {
          state.view = v.view;
          state.modeGallery = false;
          renderSVG();
          updateBgPhoto();
          updatePhotoStripActive();
        });
        D.viewButtons.appendChild(btn);
      });
    } catch (e) { console.error('CPS: updateViewButtons error', e); }
  }

  // Sync photo strip active highlight to current state.view.
  function updatePhotoStripActive() {
    try {
      if (!D.photoStrip) return;
      var keyMap = {
        tshirt: {front:'tshirt-front',back:'tshirt-back',left:'tshirt-left',right:'tshirt-right'},
        hoodie: {front:'hoodie-front',back:'hoodie-back',left:'hoodie-left',right:'hoodie-right'},
        hat:    {front:'hat-front',side:'hat-side'},
        shoes:  {side:'sneakers-side'}
      };
      var pMap = keyMap[state.product] || {};
      var activeKey = pMap[state.view] || '';
      var all = D.photoStrip.querySelectorAll('.cps-photo-btn');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('is-active', all[i].dataset.imgKey === activeKey);
      }
    } catch (e) {}
  }

  // ====== COLOR SLUG HELPER ======
  // Converts color name to filename slug: "Heather Gray" → "heather-gray"
  function colorSlug(name) {
    return (name || '').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
  }

  // Resolve image URL: tries color-specific variant first, falls back to default
  function resolveImgUrl(baseKey) {
    if (!cpData.imgs) return null;
    var slug = state.color ? colorSlug(state.color) : null;
    var colorKey = slug ? (baseKey + '-' + slug) : null;
    var url = (colorKey && cpData.imgs[colorKey]) ? cpData.imgs[colorKey] : cpData.imgs[baseKey];
    if (!url) return null;
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url;
  }

  // ====== 360° GALLERY ======
  function getGalleryImages() {
    try {
      var p = state.product;
      var imgMap = {
        tshirt: ['tshirt-front', 'tshirt-back', 'tshirt-left', 'tshirt-right'],
        hoodie: ['hoodie-front', 'hoodie-back', 'hoodie-left', 'hoodie-right'],
        hat: ['hat-front', 'hat-side'],
        shoes: ['sneakers-side']
      };
      var keys = imgMap[p] || [];
      var urls = [];
      keys.forEach(function (key) {
        var url = resolveImgUrl(key);
        if (url) urls.push({ key: key, url: url, label: key.replace(/-/g, ' ') });
      });
      return urls;
    } catch (e) { return []; }
  }

  function buildGalleryDots() {
    try {
      if (!D.galleryDots) return;
      D.galleryDots.innerHTML = '';
      state.galleryImages.forEach(function (img, idx) {
        var dot = document.createElement('button');
        dot.className = 'cps-gallery-dot' + (idx === state.galleryIdx ? ' is-active' : '');
        dot.setAttribute('aria-label', img.label);
        dot.addEventListener('click', function () {
          state.galleryIdx = idx;
          updateGalleryView();
        });
        D.galleryDots.appendChild(dot);
      });
    } catch (e) {}
  }

  function updateGalleryDots() {
    try {
      if (!D.galleryDots) return;
      var dots = D.galleryDots.querySelectorAll('.cps-gallery-dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === state.galleryIdx);
      }
    } catch (e) {}
  }

  function updateGalleryView() {
    try {
      if (!D.galleryImg || state.galleryImages.length === 0) return;
      var img = state.galleryImages[state.galleryIdx];
      D.galleryImg.src = img.url;
      D.galleryImg.alt = img.label;
      updateGalleryDots();
    } catch (e) {}
  }

  function galleryNext() {
    try {
      if (state.galleryImages.length === 0) return;
      state.galleryIdx = (state.galleryIdx + 1) % state.galleryImages.length;
      updateGalleryView();
    } catch (e) {}
  }

  function galleryPrev() {
    try {
      if (state.galleryImages.length === 0) return;
      state.galleryIdx = (state.galleryIdx - 1 + state.galleryImages.length) % state.galleryImages.length;
      updateGalleryView();
    } catch (e) {}
  }

  function showGallery() {
    try {
      state.galleryImages = getGalleryImages();
      if (state.galleryImages.length === 0) { toast('No gallery images available', 'info'); return; }
      state.galleryIdx = 0;
      state.modeGallery = true;

      if (D.svgLayer) D.svgLayer.style.display = 'none';
      if (D.canvasLayer) D.canvasLayer.style.display = 'none';
      if (D.galleryLayer) D.galleryLayer.classList.add('is-visible');

      updateGalleryView();
      buildGalleryDots();
      updateViewUI();
    } catch (e) { console.error('CPS: showGallery error', e); show2D(); }
  }

  function setupGallery() {
    try {
      state.galleryImages = getGalleryImages();
      var hasImages = state.galleryImages.length > 0;
      if (D.galleryToggle) {
        D.galleryToggle.disabled = !hasImages;
        D.galleryToggle.classList.toggle('is-disabled', !hasImages);
      }
    } catch (e) {}
  }

  function updateViewUI() {
    try {
      if (D.viewButtons) {
        var btns = D.viewButtons.querySelectorAll('.cps-view-btn');
        for (var i = 0; i < btns.length; i++) {
          btns[i].classList.toggle('is-active', btns[i].dataset.view === state.view && !state.modeGallery);
        }
      }
      if (D.galleryToggle) D.galleryToggle.classList.toggle('is-active', state.modeGallery);
      if (D.viewLabel) {
        var v = state.view.charAt(0).toUpperCase() + state.view.slice(1);
        D.viewLabel.textContent = productLabel(state.product) + ' \u2014 ' + (state.modeGallery ? '360\u00b0 Gallery' : v) + ' View';
      }
    } catch (e) {}
  }

  // ====== PHOTO STRIP ======
  function updatePhotoStrip() {
    try {
      if (!D.photoStrip || !cpData.imgs) return;
      var p = state.product;
      var imgMap = {
        tshirt: ['tshirt-front', 'tshirt-back', 'tshirt-left', 'tshirt-right'],
        hoodie: ['hoodie-front', 'hoodie-back', 'hoodie-left', 'hoodie-right'],
        hat: ['hat-front', 'hat-side'],
        shoes: ['sneakers-side']
      };
      var keys = imgMap[p] || [];
      D.photoStrip.innerHTML = '';
      keys.forEach(function (key, idx) {
        var url = resolveImgUrl(key);
        if (!url) return;
        var btn = document.createElement('button');
        btn.className = 'cps-photo-btn' + (idx === 0 ? ' is-active' : '');
        btn.dataset.imgKey = key;
        var img = document.createElement('img');
        img.src = url;
        img.alt = key.replace(/-/g, ' ');
        img.width = 56; img.height = 56;
        img.loading = 'lazy';
        btn.appendChild(img);
        btn.addEventListener('click', function () {
          var k = btn.dataset.imgKey;
          // Extract view from image key: 'tshirt-front' → 'front', 'sneakers-side' → 'side'
          var parts = k.split('-');
          state.view = parts[parts.length - 1];
          state.modeGallery = false;
          var all = D.photoStrip.querySelectorAll('.cps-photo-btn');
          for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
          btn.classList.add('is-active');
          renderSVG();
          updateBgPhoto();
          // Sync view button highlights
          if (D.viewButtons) {
            var vbtns = D.viewButtons.querySelectorAll('.cps-view-btn');
            for (var j = 0; j < vbtns.length; j++) {
              vbtns[j].classList.toggle('is-active', vbtns[j].dataset.view === state.view);
            }
          }
        });
        D.photoStrip.appendChild(btn);
      });
    } catch (e) { console.error('CPS: updatePhotoStrip error', e); }
  }

  // ====== VARIANT ======
  function resolveVariant(pd) {
    try {
      if (!pd || !pd.variants || pd.variants.length === 0) return pd && pd.variants ? pd.variants[0] : null;
      var best = null, bestScore = -1;
      pd.variants.forEach(function (v) {
        var score = 0;
        if (state.color && v.option1 && v.option1.toLowerCase() === state.color.toLowerCase()) score += 100;
        if (state.size && v.option2 && v.option2.toLowerCase() === state.size.toLowerCase()) score += 50;
        if (state.style && v.option3 && v.option3.toLowerCase() === state.style.toLowerCase()) score += 25;
        if (v.available) score += 1;
        if (score > bestScore) { bestScore = score; best = v; }
      });
      return best || pd.variants[0];
    } catch (e) { return null; }
  }

  function updateVariant() {
    try {
      var pd = cpData.products[state.product];
      state.variant = resolveVariant(pd);
      updatePrice();
    } catch (e) {}
  }

  function updatePrice() {
    try {
      var v = state.variant;
      var pd = cpData.products[state.product];
      var price = v ? v.price : (pd ? pd.price : 0);
      var total = (price || 0) * state.qty;
      if (D.price) D.price.textContent = fmt(total);
      if (D.meta) D.meta.textContent = productLabel(state.product) + ' \u00b7 ' + (state.color || '\u2014') + ' \u00b7 ' + (state.size || '\u2014');
    } catch (e) {}
  }

  // ====== PRODUCT SELECTION ======
  function selectProduct(key) {
    try {
      showLoader('Loading...');
      state.product = key;
      state.view = 'front';
      state.modeGallery = false;
      var pd = cpData.products[key];

      highlightTab(key);
      buildStyles(pd);
      buildSizes(pd);
      buildColors(pd);
      buildPlacements();
      updateViewButtons();
      setupGallery();
      updateViewUI();
      renderSVG();
      updateVariant();
      updatePhotoStrip();
      updateBgPhoto();
      hideLoader();
    } catch (e) { console.error('CPS: selectProduct error', e); }
  }

  function highlightTab(key) {
    try {
      if (!D.tabs) return;
      var tabs = D.tabs.querySelectorAll('.cps-tab');
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.toggle('is-active', tabs[i].dataset.product === key);
        tabs[i].setAttribute('aria-selected', tabs[i].dataset.product === key ? 'true' : 'false');
      }
    } catch (e) {}
  }

  // ====== STYLES ======
  function buildStyles(pd) {
    try {
      if (!D.styleSelect || !D.styleWrap) return;
      var styles = [];
      if (pd && pd.options) {
        pd.options.forEach(function (o) { if (o.name && o.name.toLowerCase() === 'style') styles = o.values || []; });
      }
      if (styles.length === 0) { D.styleWrap.style.display = 'none'; state.style = null; }
      else {
        D.styleWrap.style.display = ''; state.style = styles[0];
        D.styleSelect.innerHTML = styles.map(function (s) { return '<option value="' + s + '">' + s + '</option>'; }).join('');
      }
    } catch (e) {}
  }

  // ====== SIZES ======
  function buildSizes(pd) {
    try {
      if (!D.sizeButtons || !D.sizeWrap) return;
      var sizes = [];
      if (pd && pd.options) {
        pd.options.forEach(function (o) { if (o.name && o.name.toLowerCase() === 'size') sizes = o.values || []; });
      }
      if (sizes.length === 0) { D.sizeWrap.style.display = 'none'; state.size = null; return; }
      D.sizeWrap.style.display = '';
      state.size = sizes[0];
      if (D.sizeName) D.sizeName.textContent = sizes[0];
      D.sizeButtons.innerHTML = sizes.map(function (s) {
        return '<button class="cps-size-btn' + (s === state.size ? ' is-active' : '') + '" data-size="' + s + '">' + s + '</button>';
      }).join('');
      D.sizeButtons.querySelectorAll('.cps-size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.size = btn.dataset.size;
          if (D.sizeName) D.sizeName.textContent = state.size;
          D.sizeButtons.querySelectorAll('.cps-size-btn').forEach(function (b) { b.classList.toggle('is-active', b.dataset.size === state.size); });
          updateVariant();
        });
      });
    } catch (e) { console.error('CPS: buildSizes error', e); }
  }

  // ====== COLORS ======
  function buildColors(pd) {
    try {
      if (!D.colorSwatches) return;
      var colors = [];
      if (pd && pd.options) {
        pd.options.forEach(function (o) { if (o.name && o.name.toLowerCase() === 'color') colors = o.values || []; });
      }
      if (colors.length === 0) { state.color = 'Black'; D.colorSwatches.innerHTML = ''; renderSVG(); return; }
      state.color = colors[0];
      D.colorSwatches.innerHTML = colors.map(function (c) {
        var h = hex(c);
        return '<button class="cps-swatch' + (c === state.color ? ' is-active' : '') + '" data-color="' + c + '" title="' + c + '"><span class="cps-swatch__inner" style="background-color:' + h + '"></span></button>';
      }).join('');
      D.colorSwatches.querySelectorAll('.cps-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.color = btn.dataset.color;
          if (D.colorName) D.colorName.textContent = state.color;
          if (D.colorDisplay) D.colorDisplay.textContent = state.color;
          D.colorSwatches.querySelectorAll('.cps-swatch').forEach(function (b) { b.classList.toggle('is-active', b.dataset.color === state.color); });
          renderSVG();
          updateVariant();
          updatePhotoStrip();   // swap photo strip to color-variant images
          setupGallery();       // refresh 360° gallery for selected color
          updateBgPhoto();      // refresh stage photo for new color
        });
      });
      if (D.colorName) D.colorName.textContent = state.color;
      if (D.colorDisplay) D.colorDisplay.textContent = state.color;
    } catch (e) { console.error('CPS: buildColors error', e); }
  }

  // ====== PLACEMENTS ======
  function buildPlacements() {
    try {
      if (!D.placementButtons) return;
      var map = { tshirt: ['Front','Back','Left Chest','Full Front'], hoodie: ['Front','Back','Left Chest'], hat: ['Front','Side'], shoes: ['Side','Tongue'] };
      var pls = map[state.product] || ['Front','Back'];
      state.placement = pls[0];
      D.placementButtons.innerHTML = pls.map(function (p) {
        return '<button class="cps-placement-btn' + (p === state.placement ? ' is-active' : '') + '" data-placement="' + p + '">' + p + '</button>';
      }).join('');
      D.placementButtons.querySelectorAll('.cps-placement-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.placement = btn.dataset.placement;
          D.placementButtons.querySelectorAll('.cps-placement-btn').forEach(function (b) { b.classList.toggle('is-active', b.dataset.placement === state.placement); });
          var viewMap = { Front:'front', Back:'back', 'Left Chest':'front', 'Full Front':'front', Side:'side', Tongue:'front' };
          var nv = viewMap[state.placement] || 'front';
          if (nv !== state.view) { state.view = nv; updateViewUI(); }
          renderSVG();
          updateBgPhoto();
          updatePhotoStripActive();
        });
      });
    } catch (e) {}
  }

  // ====== HERO THUMBS ======
  function bindHeroThumbs() {
    try {
      var thumbs = document.querySelectorAll('.cps-hero__thumb[data-hero-product]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var key = thumb.dataset.heroProduct;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          // Update hero image
          if (D.heroImg && cpData.imgs) {
            var imgKey = key === 'shoes' ? 'sneakers-side' : key + '-front';
            var url = cpData.imgs[imgKey];
            if (url) {
              if (url.indexOf('//') === 0) url = 'https:' + url;
              D.heroImg.innerHTML = '<img src="' + url + '" alt="' + productLabel(key) + '" loading="eager" width="500" height="500" />';
            }
          }
          selectProduct(key);
        });
      });
    } catch (e) {}
  }

  // ====== FABRIC.JS ======
  var fabricRetries = 0;
  function initFabric() {
    try {
      if (!D.fabricCanvas) return;
      if (typeof fabric === 'undefined') {
        if (fabricRetries < 15) { fabricRetries++; setTimeout(initFabric, 500); }
        return;
      }
      var wrap = D.canvasLayer || D.fabricCanvas.parentElement;
      var rect = wrap.getBoundingClientRect();
      D.fabricCanvas.width = rect.width || 400;
      D.fabricCanvas.height = rect.height || 400;

      state.fabricCanvas = new fabric.Canvas('cps-fabric', {
        backgroundColor: 'transparent', selection: true, preserveObjectStacking: true
      });

      function updateCanvasInteractivity() {
        if (D.canvasLayer) D.canvasLayer.classList.toggle('has-objects', state.fabricCanvas.getObjects().length > 0);
      }
      state.fabricCanvas.on('object:added', updateCanvasInteractivity);
      state.fabricCanvas.on('object:removed', updateCanvasInteractivity);

      window.addEventListener('resize', debounce(function () {
        if (!state.fabricCanvas) return;
        var r = wrap.getBoundingClientRect();
        state.fabricCanvas.setWidth(r.width || 400);
        state.fabricCanvas.setHeight(r.height || 400);
        state.fabricCanvas.renderAll();
      }, 250));
    } catch (e) { console.error('CPS: initFabric error', e); }
  }

  // ====== UPLOAD ======
  function setupUpload() {
    try {
      if (!D.fileInput || !D.uploadZone) return;
      D.uploadZone.addEventListener('click', function () { D.fileInput.click(); });
      D.fileInput.addEventListener('change', function (e) { if (e.target.files[0]) handleFile(e.target.files[0]); });
      D.uploadZone.addEventListener('dragover', function (e) { e.preventDefault(); D.uploadZone.classList.add('is-dragover'); });
      D.uploadZone.addEventListener('dragleave', function () { D.uploadZone.classList.remove('is-dragover'); });
      D.uploadZone.addEventListener('drop', function (e) { e.preventDefault(); D.uploadZone.classList.remove('is-dragover'); if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]); });
      if (D.removeArt) {
        D.removeArt.addEventListener('click', function (e) {
          e.stopPropagation();
          state.artworkFile = null; state.artworkDataURL = null;
          if (D.uploadThumbWrap) D.uploadThumbWrap.classList.remove('is-visible');
          if (D.artThumb) D.artThumb.src = '';
          if (D.artName) D.artName.textContent = '';
          toast('Artwork removed', 'info');
        });
      }
    } catch (e) {}
  }

  function handleFile(file) {
    try {
      var valid = ['image/jpeg','image/png','image/svg+xml','image/webp','application/pdf'];
      if (valid.indexOf(file.type) === -1) { toast('Invalid format. Use PNG, JPG, SVG, WebP, or PDF.', 'error'); return; }
      if (file.size > 25 * 1024 * 1024) { toast('File too large. Max 25MB.', 'error'); return; }
      var reader = new FileReader();
      reader.onload = function (e) {
        state.artworkFile = file;
        state.artworkDataURL = e.target.result;
        if (D.artThumb) D.artThumb.src = state.artworkDataURL;
        if (D.artName) D.artName.textContent = file.name;
        if (D.uploadThumbWrap) D.uploadThumbWrap.classList.add('is-visible');
        addImageToCanvas(state.artworkDataURL);
        toast('Artwork uploaded', 'success');
      };
      reader.readAsDataURL(file);
    } catch (e) { toast('Upload failed', 'error'); }
  }

  function addImageToCanvas(dataURL) {
    try {
      if (!state.fabricCanvas) return;
      fabric.Image.fromURL(dataURL, function (img) {
        var sc = Math.min(200 / img.width, 200 / img.height, 0.5);
        img.set({ left: 50, top: 50, scaleX: sc, scaleY: sc });
        state.fabricCanvas.add(img);
        state.fabricCanvas.setActiveObject(img);
        state.fabricCanvas.renderAll();
      });
    } catch (e) {}
  }

  // ====== TEXT ======
  function setupText() {
    try {
      if (D.fontSize) { D.fontSize.addEventListener('input', function () { if (D.fontSizeVal) D.fontSizeVal.textContent = D.fontSize.value; }); }
      if (D.addText) {
        D.addText.addEventListener('click', function () {
          if (!state.fabricCanvas || !D.textInput) return;
          var txt = D.textInput.value.trim();
          if (!txt) { toast('Enter text first', 'error'); return; }
          var font = D.fontSelect ? D.fontSelect.value : 'DM Sans';
          var color = D.textColor ? D.textColor.value : '#000000';
          var size = D.fontSize ? parseInt(D.fontSize.value, 10) : 36;
          var t = new fabric.IText(txt, { left: 80, top: 80, fontFamily: font, fontSize: size, fill: color, editable: true });
          state.fabricCanvas.add(t);
          state.fabricCanvas.setActiveObject(t);
          state.fabricCanvas.renderAll();
          D.textInput.value = '';
          toast('Text added', 'success');
        });
      }
    } catch (e) {}
  }

  function initFonts() {
    try {
      var fonts = ['DM Sans','Arial Black','Georgia','Impact','Courier New','Trebuchet MS','Verdana','Comic Sans MS','Lucida Console'];
      if (D.fontSelect) D.fontSelect.innerHTML = fonts.map(function (f) { return '<option value="' + f + '">' + f + '</option>'; }).join('');
    } catch (e) {}
  }

  // ====== QUANTITY ======
  function setupQty() {
    try {
      if (D.qtyMinus) D.qtyMinus.addEventListener('click', function () { if (state.qty > 1) { state.qty--; updateQty(); } });
      if (D.qtyPlus) D.qtyPlus.addEventListener('click', function () { state.qty++; updateQty(); });
    } catch (e) {}
  }
  function updateQty() { if (D.qtyVal) D.qtyVal.textContent = state.qty; updatePrice(); }

  // ====== MISC ======
  function setupMisc() {
    try {
      if (D.proofToggle) D.proofToggle.addEventListener('change', function (e) { state.proof = e.target.checked; });
      if (D.notes) D.notes.addEventListener('input', function (e) { state.notes = e.target.value; });
      if (D.styleSelect) D.styleSelect.addEventListener('change', function (e) { state.style = e.target.value; updateVariant(); });
    } catch (e) {}
  }

  // ====== ADD TO CART ======
  function addToCart() {
    try {
      if (!state.variant || !state.variant.id) { toast('Please select a valid variant', 'error'); return; }
      var payload = {
        id: state.variant.id, quantity: state.qty,
        properties: {
          '_product_type': state.product, '_color': state.color || '', '_size': state.size || '',
          '_placement': state.placement || '', 'Custom Text': D.textInput ? D.textInput.value : '',
          'Font': D.fontSelect ? D.fontSelect.value : '', 'Design Notes': state.notes,
          'Proof Required': state.proof ? 'Yes' : 'No',
          'Artwork File': state.artworkFile ? state.artworkFile.name : ''
        }
      };
      D.addToCart.disabled = true;
      D.addToCart.textContent = 'ADDING...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function () {
          toast('Added to cart!', 'success');
          D.addToCart.disabled = false;
          D.addToCart.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> ADD TO CART';
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (d) {
            var badge = document.querySelector('[data-cart-count]');
            if (badge) badge.textContent = d.item_count;
          }).catch(function () {});
        })
        .catch(function (err) {
          console.error('Cart error:', err);
          toast('Failed to add. Try again.', 'error');
          D.addToCart.disabled = false;
          D.addToCart.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> ADD TO CART';
        });
    } catch (e) { toast('Error adding to cart', 'error'); }
  }

  // ====== BIND EVENTS ======
  function bindEvents() {
    try {
      // Product tabs
      if (D.tabs) {
        D.tabs.querySelectorAll('.cps-tab').forEach(function (tab) {
          tab.addEventListener('click', function () { selectProduct(tab.dataset.product); });
        });
      }
      // View buttons are bound dynamically in updateViewButtons()
      // Gallery toggle
      if (D.galleryToggle) D.galleryToggle.addEventListener('click', function () { if (state.modeGallery) show2D(); else showGallery(); });
      // Gallery prev/next
      if (D.galleryPrev) D.galleryPrev.addEventListener('click', galleryPrev);
      if (D.galleryNext) D.galleryNext.addEventListener('click', galleryNext);
      // Add to cart
      if (D.addToCart) D.addToCart.addEventListener('click', addToCart);
      // Update product tab prices
      if (D.tabs) {
        var prods = cpData.products || {};
        Object.keys(prods).forEach(function (key) {
          var el = D.tabs.querySelector('[data-price-for="' + key + '"]');
          if (el && prods[key].price) el.textContent = fmt(prods[key].price);
        });
      }
    } catch (e) { console.error('CPS: bindEvents error', e); }
  }

  // ====== PARSE DATA ======
  function parseData() {
    try {
      var dataEl = document.getElementById('cps-shopify-data');
      if (!dataEl) { console.warn('CPS: no data element'); return; }
      var raw = dataEl.textContent || dataEl.innerText || '';
      try {
        cpData = JSON.parse(raw);
      } catch (e1) {
        console.warn('CPS: JSON parse failed, trying fallback', e1);
        cpData = { products: {}, imgs: {} };
        try {
          var imgsMatch = raw.match(/"imgs"\s*:\s*(\{[^}]+\})/);
          if (imgsMatch) cpData.imgs = JSON.parse(imgsMatch[1]);
        } catch (e2) {}
      }
      window.__CPS__ = cpData;
    } catch (e) {
      console.error('CPS: parseData error', e);
      cpData = { products: {}, imgs: {} };
    }
  }

  // ====== INIT ======
  function init() {
    try {
      cacheDom();
      if (!D.root) { console.error('CPS: root #cps-root not found'); return; }

      parseData();

      // Start hero canvas animation
      initHeroCanvas();

      initFonts();
      bindEvents();
      bindHeroThumbs();

      // Apply initial color to the default SVG
      var initialColor = 'Black';
      var tshirtData = cpData.products && cpData.products.tshirt;
      if (tshirtData && tshirtData.options) {
        tshirtData.options.forEach(function (o) {
          if (o.name && o.name.toLowerCase() === 'color' && o.values && o.values.length > 0) {
            initialColor = o.values[0];
          }
        });
      }
      state.color = initialColor;

      // Render the initial SVG with the correct color
      renderSVG();

      // Select default product (builds all controls)
      selectProduct('tshirt');

      // Init fabric.js (with retry for deferred loading)
      initFabric();
      setupUpload();
      setupText();
      setupQty();
      setupMisc();

      console.log('CPS v11: initialized successfully');
    } catch (e) {
      console.error('CPS: init error', e);
    }
  }

  // ====== BOOT ======
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
